export const LIST_REPORT_DAILY = 'LIST_REPORT_DAILY';
export const LIST_REPORT_MONTHLY = 'LIST_REPORT_MONTHLY';
export const LIST_REPORT_REVENUE = 'LIST_REPORT_REVENUE';